import Color from 'color';
export const convertToLighterRgba = (color) => color ? Color(color).lighten(0.5).rgb().string() : null;
//# sourceMappingURL=convertToLighterRgba.js.map